import styles from "./frontpage.module.scss";

const Video = () => {
  return (
    <div>
      <video
        className={styles.video}
        autoPlay
        muted
        playsInline
        loop
        poster="/media/videos/graphs_poster.webp"
        preload="auto"
      >
        <source
          src="/media/videos/graphs_high_res.webm"
          type="video/webm"
        />
        <source
          src="/media/videos/graphs_high_res.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  );
};

export default Video;
